import Button from "@/components/base/Button";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { useUi } from "@/context/UiContext";

const TAGS = ["方向型", "信念型", "啟動型", "持續型", "能力型"];

export default function ProblemSection() {
  const { openQuiz } = useUi();

  return (
    <section className="bg-white">
      <div className="mx-auto max-w-container px-4 md:px-6 py-14 md:py-20 lg:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
          <div className="lg:col-span-5">
            <Reveal>
              <SectionHeading
                eyebrow="先看問題"
                title="你缺的，可能不是更多知識。"
              />
            </Reveal>
          </div>
          <div className="lg:col-span-7">
            <Reveal delay={80}>
              <p className="text-base leading-[1.85] text-ink">
                你也有過這些狀態嗎？
              </p>
              <ul className="mt-4 space-y-2 text-base leading-[1.8] text-ink-soft">
                <li>知道很多，卻一直沒有真正開始。</li>
                <li>開始很多次，卻總是半途而廢。</li>
                <li>每天很忙，卻不知道自己真正要往哪裡走。</li>
                <li>明明很想改變，卻經常懷疑自己做不做得到。</li>
              </ul>
              <p className="mt-6 text-base leading-[1.8] text-ink">
                問題不一定只是「不夠自律」。真正需要先理解的是：
                <span className="font-semibold text-primary">我到底卡在哪裡？</span>
              </p>

              <div className="mt-8 flex flex-wrap gap-3">
                {TAGS.map((t) => (
                  <span
                    key={t}
                    className="inline-flex items-center gap-2 rounded-full bg-gold-soft/60 border border-line px-4 py-2 text-sm font-medium text-primary"
                  >
                    {t}
                  </span>
                ))}
              </div>

              <div className="mt-8">
                <Button onClick={openQuiz} icon="ri-arrow-right-line">
                  30 秒找出我的行動卡點
                </Button>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}